import { defineComponent, reactive, computed } from 'vue';
import ValueBox from '@/components/box/ValueBox.vue';
export default defineComponent({
    name: 'EnergyBalanceNavigator',
    components: {
        ValueBox,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        locale: {
            type: String,
            required: false,
            default: 'en',
        },
        siteConfigurationInfo: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const state = reactive({
            data: computed(() => getSortedData(props.data)),
            siteConfigurationInfo: computed(() => ({
                hasAcSystem: props.siteConfigurationInfo?.hasAcSystem,
                hasESS: props.siteConfigurationInfo?.hasESS,
                hasHub: props.siteConfigurationInfo?.hasHub,
                hasPV: props.siteConfigurationInfo?.hasPV,
                hasThirdParty: props.siteConfigurationInfo?.hasThirdParty,
            })),
        });
        const cardOrder = [
            ['generation', 'consumption'],
            ['demand', 'feedin'],
            ['discharging', 'charging'],
        ];
        function getSortedData(data) {
            const _data = filterIsConfig(data);
            return cardOrder
                .map((row) => {
                return [
                    ...row.map((col) => {
                        return _data?.thisYear?.find((item) => item.id === col);
                    }),
                ];
            })
                .filter((item) => !checkIfAllItemNull(item));
        }
        function checkIfAllItemNull(arr) {
            return arr.every((item) => item === null || item === undefined);
        }
        function filterIsConfig(data) {
            if (!state.siteConfigurationInfo.hasPV) {
                return { ...data, thisYear: data?.thisYear.filter((item) => item.id !== 'generation') };
            }
            if (!state.siteConfigurationInfo.hasESS) {
                return { ...data, thisYear: data?.thisYear.filter((item) => !['charging', 'discharging'].includes(item.id)) };
            }
            return data;
        }
        return { state };
    },
});
